export const VEHICLE_CONTEXT_KEY = 'vehicle_navigation_context'

const safely = fn => {
  try {
    return fn()
  } catch {
    return null
  }
}

export const readVehicleContext = () => {
  if (typeof window === 'undefined') return null
  return safely(() => {
    const raw = window.sessionStorage.getItem(VEHICLE_CONTEXT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || !parsed.id || !parsed.params || !parsed.params.typeid) {
      return null
    }
    return parsed
  })
}

export const writeVehicleContext = context => {
  if (typeof window === 'undefined') return
  safely(() =>
    window.sessionStorage.setItem(VEHICLE_CONTEXT_KEY, JSON.stringify(context))
  )
}

export const clearVehicleContext = () => {
  if (typeof window === 'undefined') return
  safely(() => window.sessionStorage.removeItem(VEHICLE_CONTEXT_KEY))
}
